import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Alert,
  AlertIcon,
  Box,
  Stack,
} from "@chakra-ui/react";
import moment from "moment";
import React, { useMemo } from "react";
import { useBookings } from "../../data/occupancy.api";
import QueryStateWrapper from "../QueryStateWrapper";
import BookingCard from "./BookingCard";

type Props = {};

const MyBookings = (props: Props) => {
  const { data, isLoading, error } = useBookings();

  const futureBookings = useMemo(() => {
    return data?.bookings.filter((booking) =>
      moment(booking.endDate).isSameOrAfter(moment())
    );
  }, [data]);

  const pastBookings = useMemo(() => {
    return data?.bookings.filter((booking) =>
      moment(booking.endDate).isBefore(moment())
    );
  }, [data]);

  return (
    <QueryStateWrapper isLoading={isLoading} error={error} data={data}>
      <Stack>
        {futureBookings && futureBookings.length > 0 ? (
          futureBookings.map((booking) => <BookingCard booking={booking} />)
        ) : (
          <Alert>
            <AlertIcon />
            You don't have any bookings in the future
          </Alert>
        )}
        {pastBookings && pastBookings.length > 0 ? (
          <Accordion mt={5} allowMultiple>
            <AccordionItem mb={2} border={0}>
              <AccordionButton>
                <Box flex="1" textAlign="left" opacity={0.8}>
                  View past bookings
                </Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel px={0}>
                <Stack>
                  {pastBookings.map((booking) => (
                    <BookingCard booking={booking} />
                  ))}
                </Stack>
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        ) : null}
      </Stack>
    </QueryStateWrapper>
  );
};

export default MyBookings;
